import { Component, Shark } from "shark-mvc";

import organizationManager from "../managers/organizationManager";
import organizationMembershipManager from "../managers/organizationMembershipManager";
import notificationManager from "../managers/notificationManager";
import userManager from "../managers/userManager";
import OrganizationMembership from "../models/OrganizationMembership";
import workSessionManager from "../managers/workSessionManager";
import activeWorkSessionDisplayComponent from "./activeWorkSessionDisplay/activeWorkSessionDisplayComponent";

class SystemComponent extends Component {
	constructor () {
		super("systemComponent");
	}

	async checkAppVersion () {
		return fetch(Shark.$store.cdnURL + "/js/app-version.json")
		.then(response => response.json())
		.then(data => {
			return data;
		});
	}

	checEMail (eMailAdress) {
		const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
	
		return regex.test(eMailAdress); 
	}

	// Alice.TODO: usa questa per mostratre le organizzazioni nelle quali puoi aggiungere un progetto 
	async getWritableOrganizationList () {
		let { currUser, organizationList, organizationMembershipList, writableOrganizationList } = Shark.get();

		if (!organizationList || organizationList.length === 0) {
			const organizationListResult = await organizationManager.getListForCurrentUser();
			organizationList = organizationListResult.data;
		}

		if (!organizationList || organizationList.length === 0) {
			const organizationMembershipListResult = await organizationMembershipManager.getList();
			organizationMembershipList = organizationMembershipListResult.data;
		}

		if (!writableOrganizationList && organizationList && organizationMembershipList) {
			const writableOrganizationList = organizationList.filter(organization => {
				const myMembership = organizationMembershipList.find(membership => membership.userGuid === currUser.guid && membership.organizationGuid === organization.guid);
				// console.log(myMembership);
				return [OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(myMembership?.role);
			});

			Shark.set({
				// @Alice: Questa cosa sotto è sbagliata, quello che volevi fare si scrive !(organizationList.lenght > 0)
				//  Ma è insensato: non vuoi sapere se l'inverso della lunghezza = 0 è vero... vuoi sapere se la lunghezza è 0...
				// __firstOrganizationToAdd: !organizationList.lenght > 0,
				__firstOrganizationToAdd: organizationList.lenght === 0,
				writableOrganizationList,
			});
		}
	}

	async prepareSystemData () {
		notificationManager.setActiveVoice();

		await organizationMembershipManager.getList();
		const organizationListResponse = await organizationManager.getListForCurrentUser();
		const allUserListResponse = await userManager.getListForMyOrganization();
		await organizationMembershipManager.getListByOrganizationGuidList(organizationListResponse.data.map(item => item.guid));
		await this.getWritableOrganizationList();

		const { currUser } = Shark.get();
		let allUserList = [];
		if (allUserListResponse.data.length > 0) {
			allUserList = allUserListResponse.data;
			const otherUserList = allUserList.filter(item => item.guid !== currUser.guid);

			Shark.set({
				allUserList,
				otherUserList,
			});
		}
		// Fix temporaneo se non hai organizzazioni devi comunque essere aggiunto alla user list
		else {
			allUserList = [currUser];

			Shark.set({
				allUserList,
			});
		} 
	}

	async checkOpenWorkSession () {
		if (!activeWorkSessionDisplayComponent.$store.autoSavePending) {
			const { currUser } = Shark.get();

			if (currUser && currUser.guid !== "") {
				return workSessionManager.checkOpenByUser(currUser)
				.then(() => {
					if (!Shark.get("runningWorkSession") || Shark.get("runningWorkSession").guid === "") {
						notificationManager.startShouldBeWorkingNotifications();
						document.title = "TimeCorder";
					}
					else {
						notificationManager.stopNotWorkingTimeNotifications();
					}
					
					return true;
				});
			}
		}
	}

	includesAny(array1, array2) {
		for(let i = 0; i < array2.length; i++) {
			if (array1.includes(array2[i])) {
				return true;
			}		
		};
		return false;
	}

	sortByName (list) {
		list.sort((a, b) => {
			if (a.name.toLowerCase() > b.name.toLowerCase()) {
				return 1;
			}
			else if (a.name.toLowerCase() < b.name.toLowerCase()) {
				return -1;
			}
		});
	}
}

const systemComponent = new SystemComponent();

Shark.registerComponent(systemComponent);

export default systemComponent;